import React from "react";
import { statusLabel } from "utilities/registrationTimeline";

/**
 * SOUND-643 — registration status pill.
 *
 * Same construction as components/Tickets/TicketStatusPill: a design-system
 * badge tone plus a leading dot. Deliberately a SEPARATE component rather than
 * reusing that one, for the reason its own comment gives — ticket, MID and
 * registration statuses are different vocabularies that share key names
 * (`new`, `approved`, `declined`), so one lookup table would collide.
 *
 * Tones mirror the dot colours in utilities/registrationTimeline, so a status
 * reads the same in the pill and on the timeline rail.
 */
const TONE = {
  // `new` takes the brand dot for the same reason ticket `open` does: freshest,
  // needs pickup.
  new: { badge: "badge-muted", dot: "bg-brand" },
  in_progress: { badge: "badge-info", dot: "bg-current" },
  submitted: { badge: "badge-info", dot: "bg-current" },
  needs_info: { badge: "badge-warning", dot: "bg-current" },
  approved: { badge: "badge-success", dot: "bg-current" },
  rejected: { badge: "badge-destructive", dot: "bg-current" },
};

export default function RegistrationStatusPill({ status, className = "" }) {
  const key = status || "new";
  const tone = TONE[key] || TONE.new;
  const label = statusLabel(key);

  return (
    <span
      className={`badge ${tone.badge} ${className}`}
      title={`Status: ${label}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${tone.dot}`} aria-hidden="true" />
      {label}
    </span>
  );
}
